/**
 * BP Cookie Consent v2 (Standalone Version)
 * No JSON fetching. Configuration is set directly in this file.
 */

console.log("✅ Scripts.js Loaded");

// ✅ Banner content directly set inside JavaScript
const bpccBannerText = `<p>Folosim cookie-uri pentru a îmbunătăți experiența ta de navigare, a afișa reclame sau conținut personalizat și a analiza traficul nostru.</p>
    <p>Prin apăsarea butonului <strong>„De acord”</strong>, îți dai consimțământul pentru utilizarea cookie-urilor de către noi. Folosim aceste cookie-uri exclusiv în scopul de:</p>
    <ul>
        <li>Furnizării și menținerii serviciilor website-ului;</li>
        <li>Măsurării interacțiunii utilizatorilor și creării de statistici despre utilizarea website-ului;</li>
        <li>Difuzării anunțurilor și măsurării eficienței acestora;</li>
        <li>Afișării de conținut personalizat pe baza setărilor tale.</li>
    </ul>`;

const bpccButtonAccept = "De acord";
const bpccButtonReject = "Resping";
const bpccButtonPreferences = "⚙";

// ✅ Ensure DOM is loaded before running
document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ DOM Loaded - Initializing BP Cookie Consent");

    // ✅ Ensure elements exist before modifying them
    const bannerTextEl = document.getElementById("cookie-consent-v2-banner-text");
    const acceptButtonEl = document.getElementById("cookie-consent-v2-accept-button");
    const rejectButtonEl = document.getElementById("cookie-consent-v2-reject-button");
    const preferencesButtonEl = document.getElementById("cookie-consent-v2-preferences-button");
    const duplicatePreferencesButtonEl = document.getElementById("cookie-consent-v2-preferences-button-duplicate");
    const bannerEl = document.getElementById("cookie-consent-v2-banner");
    const modalEl = document.getElementById("cookie-consent-v2-preferences-modal");
    const closeButtonEl = document.querySelector("#cookie-consent-v2-preferences-modal .close");

    if (bannerTextEl) bannerTextEl.innerHTML = bpccBannerText;
    if (acceptButtonEl) acceptButtonEl.textContent = bpccButtonAccept;
    if (rejectButtonEl) rejectButtonEl.textContent = bpccButtonReject;
    if (preferencesButtonEl) preferencesButtonEl.textContent = bpccButtonPreferences;

// ✅ Function to wait for gtag before updating consent
function updateConsentOnceGtagIsLoaded() {
    if (typeof gtag === "function") {
        console.log("📡 Sending initial consent update (denied)");
        gtag("consent", "update", {
            ad_storage: "denied",
            analytics_storage: "denied",
            personalization_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            functionality_storage: "granted",
            security_storage: "granted",
        });

        console.log("✅ Consent update sent.");
    } else {
        console.warn("⚠️ gtag not available yet, retrying in 500ms...");
        setTimeout(updateConsentOnceGtagIsLoaded, 500);
    }
}

// ✅ Ensure GTM has loaded before updating consent
window.addEventListener("gtm.js", function () {
    console.log("✅ GTM fully loaded, updating consent.");
    updateConsentOnceGtagIsLoaded();
});

// ✅ Check if consent cookie exists
if (bannerEl && !getCookie("cookie_consent_v2_state")) {
    console.log("🛑 No consent cookie found. Showing banner.");

    // Call function to wait for gtag
    updateConsentOnceGtagIsLoaded();

    // Show the banner
    bannerEl.style.display = "block";
}

function updatePreferencesModal() {
    const consentCookie = getCookie("cookie_consent_v2_state");

    const analyticsCheckbox = document.getElementById("analytics-consent");
    const advertisingCheckbox = document.getElementById("advertising-consent");

    if (!analyticsCheckbox || !advertisingCheckbox) {
        console.warn("⚠️ Checkbox elements not found. Cannot update preferences modal.");
        return;
    }

    if (consentCookie) {
        try {
            const consentState = JSON.parse(consentCookie);

            analyticsCheckbox.checked = consentState.analytics_storage === "granted";
            advertisingCheckbox.checked = consentState.ad_storage === "granted";

            console.log("✅ Preferences Modal Updated:", consentState);
        } catch (e) {
            console.warn("⚠️ Invalid consent cookie. Resetting to default (both checked).");
            analyticsCheckbox.checked = true;
            advertisingCheckbox.checked = true;
        }
    } else {
        console.log("⚠️ No consent cookie found. Defaulting to both checked.");
        analyticsCheckbox.checked = true;
        advertisingCheckbox.checked = true;
    }
}



    // ✅ Set up event listeners only if elements exist
    if (acceptButtonEl) {
        acceptButtonEl.addEventListener("click", function () {
            updateConsent(true, true);

                  // ✅ Also click Shopify's Accept button (if it exists)
        const shopifyAcceptBtn = document.getElementById("shopify-pc__banner__btn-accept");
        if (shopifyAcceptBtn) {
            shopifyAcceptBtn.click();
            console.log("👉 True click on Shopify's native Accept button");
        } else {
            console.warn("❌ Shopify Accept button not found (yet)");
        }

        });
    }

    if (rejectButtonEl) {
        rejectButtonEl.addEventListener("click", function () {
            updateConsent(false, false);

                  // ✅ Still trigger Shopify's accept button to force tracking
        const shopifyAcceptBtn = document.getElementById("shopify-pc__banner__btn-accept");
        if (shopifyAcceptBtn) {
            shopifyAcceptBtn.click();
            console.log("👉 Keep Shopify at least to number the visitors");
        } else {
            console.warn("❌ Shopify Accept button not found during Reject handling");
        }
        });
    }

    const savePreferencesButton = document.getElementById("cookie-consent-v2-save-preferences");
    if (savePreferencesButton) {
        savePreferencesButton.addEventListener("click", function () {
            const analytics = document.getElementById("analytics-consent")?.checked || false;
            const advertising = document.getElementById("advertising-consent")?.checked || false;
            updateConsent(analytics, advertising);
            modalEl.style.display = "none";
        });
    }

// ✅ Open Preferences Modal from Cookie Banner (when there is no cookie generated)
if (preferencesButtonEl) {
    preferencesButtonEl.addEventListener("click", function () {
        console.log("🔄 Opening Preferences Modal... (No cookie detected)");

        // Default both checkboxes to checked
        document.getElementById("analytics-consent").checked = true;
        document.getElementById("advertising-consent").checked = true;

        modalEl.style.display = "block";
    });
}

// ✅ Open Preferences Modal from Website button (when there is a cookie generated)
if (duplicatePreferencesButtonEl) {
    duplicatePreferencesButtonEl.addEventListener("click", function () {
        console.log("🔄 Opening Preferences Modal from duplicate button... (Checking existing cookie)");

        // Call function to update checkboxes based on existing cookie
        updatePreferencesModal();

        // Wait 50ms to ensure UI updates before showing modal
        setTimeout(() => {
            modalEl.style.display = "block";
        }, 50);
    });
}



    // ✅ Close Preferences Modal
    if (closeButtonEl) {
        closeButtonEl.addEventListener("click", function () {
            console.log("🔄 Closing Preferences Modal...");
            modalEl.style.display = "none";
        });
    }
});

// ✅ Get cookie function
function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : "";
}

// ✅ Set cookie function
function setCookie(name, value, days = 730) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; SameSite=None; Secure`;
}

// ✅ Update consent and send to GA4
function updateConsent(analytics, advertising) {
    console.log("🔄 Updating consent...");

    const consentState = {
        ad_storage: advertising ? "granted" : "denied",
        analytics_storage: analytics ? "granted" : "denied",
        personalization_storage: analytics ? "granted" : "denied",
        ad_user_data: advertising ? "granted" : "denied",
        ad_personalization: advertising ? "granted" : "denied",
        functionality_storage: "granted",
        security_storage: "granted",
        timestamp: Math.floor(Date.now() / 1000),
    };

    setCookie("cookie_consent_v2_state", JSON.stringify(consentState), 730);
    gtag("consent", "update", consentState);

    const bannerEl = document.getElementById("cookie-consent-v2-banner");
    if (bannerEl) bannerEl.style.display = "none";

    console.log("✅ Consent updated:", consentState);

    // ✅ NEW: Apply Shopify consent if appropriate
    if ((window.Shopify?.customerPrivacy?.setTrackingConsent) && (analytics || advertising)) {
        window.Shopify.customerPrivacy.setTrackingConsent({
            analytics: analytics,
            marketing: advertising,
            preferences: true
        }, function () {
            console.log("🎉 Shopify setTrackingConsent applied based on user consent");
        });
    } else {
        console.log("ℹ️ Shopify consent not applied (either no API or consent not granted)");
    }
  
}
